import './SearchInput.scss';

type SearchInputCallbacks = {
    onChange: (searchString: string) => void;
};

type SearchInputProps = {
    initialQuery?: string;
};

export class SearchInput {
    private readonly root: HTMLDivElement;
    private readonly callbacks: SearchInputCallbacks;
    private readonly initialQuery: string;

    constructor(root: HTMLDivElement, callbacks: SearchInputCallbacks, props?: SearchInputProps) {
        this.root = root;
        this.callbacks = callbacks;
        this.initialQuery = props?.initialQuery || '';
        this.render();
    }

    private render(): void {
        this.root.innerHTML = this.getHTML();
        const inputElement = this.root.querySelector('.search-input') as HTMLInputElement;
        if (inputElement && this.initialQuery) {
            inputElement.value = this.initialQuery;
        }
        inputElement.addEventListener('input', (event: Event) => {
            this.callbacks.onChange((event.target as HTMLInputElement).value);
        });
    }

    private getHTML(): string {
        return `
              <div class="search-input-container">
                  <input type="text" class="search-input" placeholder="" value="${this.initialQuery}">
                  <div class="search-input-icon-magnitude"></div>
              </div>
          `;
    }
}
